import { render, staticRenderFns } from "./site-index.vue?vue&type=template&id=128902ea&"
import script from "./site-index.vue?vue&type=script&lang=js&"
export * from "./site-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports